import { useStore } from 'effector-react'

import {
  $partnerClients,
  $totalCountOfPartnerClients,
  partnerClientsListMounted,
  getPartnerClients,
} from './model'
import { PartnerClientRequest } from './types'

export const usePartnerClientsList = () => {
  const onChangePartnerClientsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: PartnerClientRequest) => {
    partnerClientsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  const loading = useStore(getPartnerClients.pending)

  const partnerClients = useStore($partnerClients)
  const totalCountOfPartnerClients = useStore($totalCountOfPartnerClients)

  return {
    partnerClients,
    totalCountOfPartnerClients,
    loading,
    onChangePartnerClientsList,
  }
}
